<template>
  <div class="container">
    <div style="width: 100%; height: 100%" ref="container">
      <div class="first" @mousewheel="scrollToSecond" @touchmove="scrollToSecond">
        <div class="banner flex">
          <div class="banner-content">
            <div class="banner-title">朱雀实验室</div>
            <p class="banner-text">
              朱雀实验室是腾讯安全平台部于2019年成⽴的顶级安全实验室，专注于AI⼤模型领域的安全攻防实战与前瞻安全技术研究，团队成员包含了来⾃AI安全、Web安全、IoT安全、移动安全与云原⽣安全等领域的安全专家。朱雀实验室近年来聚焦于AI与⼤模型基础设施安全、⼤模型内⽣安全、⼤模型赋能安全与⼤模型安全性评测等多个⽅向，产出了大量⾏业领先的研究成果，团队通过将前沿研究成果与蓝军实战演练相结合，持续保障与提升了腾讯AI⼤模型业务的整体安全性。
            </p>
            <div class="flex main-info" style="margin-top: 40px">
              <div>
                <span class="info-name" style="display: inline-block; width: 42px">
                  别&nbsp;&nbsp;&nbsp;名
                </span>
                <span>
                  <span>腾讯朱雀实验室</span>
                  <el-link
                    type="primary"
                    class="info-link"
                    href="https://baike.baidu.com/item/%E6%9C%B1%E9%9B%80%E5%AE%9E%E9%AA%8C%E5%AE%A4"
                    target="_blank"
                    title="点击查看百度百科"
                  >
                    百科
                  </el-link>
                </span>
              </div>
              <div>
                <span class="info-name">外⽂名</span>
                <span>Tencent Zhuque Lab</span>
              </div>
            </div>
            <div class="flex main-info">
              <div>
                <span class="info-name">发起者</span>
                <span>杨勇，腾讯安全平台部负责⼈</span>
              </div>
              <div>
                <span class="info-name">负责⼈</span>
                <span>郑兴，腾讯朱雀实验室总监</span>
              </div>
            </div>
          </div>
        </div>
        <div class="advantage flex">
          <div>
            <div class="block-title">研究⽅向</div>
            <div class="flex advantage-div">
              <div class="advantage-content flex">
                <div class="advantage-img advantage-img-1"></div>
                <div class="advantage-content-div">
                  <div class="advantage-sub-title">AI⼤模型基础设施安全</div>
                  <div class="advantage-text">
                    通过红蓝对抗演习、上线前安全评估与开源组件漏洞评估收敛安全⻛险
                  </div>
                </div>
              </div>
              <div class="advantage-content flex">
                <div class="advantage-img advantage-img-2"></div>
                <div class="advantage-content-div">
                  <div class="advantage-sub-title">AI⼤模型内⽣安全</div>
                  <div class="advantage-text">
                    包含Prompt注⼊、模型后⻔、对抗攻击与越狱攻击等，曾发布⾸个AI模型后⻔⽂件级构造技术
                  </div>
                </div>
              </div>
              <div class="advantage-content flex">
                <div class="advantage-img advantage-img-3"></div>
                <div class="advantage-content-div">
                  <div class="advantage-sub-title">AI⼤模型赋能安全</div>
                  <div class="advantage-text">
                    探索将⼤模型应⽤于代码漏洞⾃动化修复、⾃动化安全⻛险巡检等场景，并在腾讯内部业务落地
                  </div>
                </div>
              </div>
              <div class="advantage-content flex">
                <div class="advantage-img advantage-img-1"></div>
                <div class="advantage-content-div">
                  <div class="advantage-sub-title">AI⼤模型评测</div>
                  <div class="advantage-text">
                    ⾃研⼤模型Prompt⾃动化安全评测平台，⽹络安全⼤模型能⼒评测平台Secbench
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="second" ref="second" @mousewheel="scrollToFirst" @touchmove="scrollToFirst">
        <div class="block-title">团队成果</div>
        <div class="flex advantage-div dataset-list">
          <div class="advantage-content">
            <div class="advantage-sub-title">⼤语⾔模型（LLM）安全性测评基准 V1.0</div>
            <div class="dataset-des">
              <el-tooltip
                class="item"
                effect="light"
                content="为评估⼤语⾔模型应⽤及服务的安全性，腾讯混元⼤模型、腾讯朱雀实验室联合清华⼤学、OWASP中国推出⼤语⾔模型（LLM）安全性测评基准，旨在评估⼤语⾔模型在Prompt安全和内容安全⽅⾯的能⼒，为企业的⼤语⾔模型应⽤或服务改进提供建议和指导。"
                placement="right"
                :visible-arrow="false"
                popper-class="popper"
                style="border: none"
              >
                <el-button type="text">
                  为评估⼤语⾔模型应⽤及服务的安全性，腾讯混元⼤模型、腾讯朱雀实验室联合清华⼤学、OWASP中国推出⼤语⾔模型（LLM）安全性测评基准，旨在评估⼤语⾔模型在Prompt安全和内容安全⽅⾯的能⼒，为企业的⼤语⾔模型应⽤或服务改进提供建议和指导。
                </el-button>
              </el-tooltip>
            </div>
          </div>
          <div class="advantage-content">
            <div class="advantage-sub-title">
              ⼤模型安全与伦理研究报告2024：以负责任AI引领⼤模型创新
            </div>
            <div class="dataset-des">
              <el-tooltip
                class="item"
                effect="light"
                content="腾讯发布了⼤模型安全⽩⽪书《⼤模型安全与伦理研究报告2024：以负责任AI引领⼤模型创新》。⽩⽪书由腾讯朱雀实验室、腾讯研究院、腾讯混元⼤模型、清华⼤学深圳国际研究⽣院、浙江⼤学区块链与数据安全全国重点实验室联合研究撰写，对⼤模型发展中的安全机遇与挑战、⼤模型安全框架和实践做法、AI伦理和价值对⻬进⾏了系统性梳理，并展望了⼤模型安全与伦理未来趋势。"
                placement="right"
                :visible-arrow="false"
                popper-class="popper"
                style="border: none"
              >
                <el-button type="text">
                  腾讯发布了⼤模型安全⽩⽪书《⼤模型安全与伦理研究报告2024：以负责任AI引领⼤模型创新》。⽩⽪书由腾讯朱雀实验室、腾讯研究院、腾讯混元⼤模型、清华⼤学深圳国际研究⽣院、浙江⼤学区块链与数据安全全国重点实验室联合研究撰写，对⼤模型发展中的安全机遇与挑战、⼤模型安全框架和实践做法、AI伦理和价值对⻬进⾏了系统性梳理，并展望了⼤模型安全与伦理未来趋势。
                </el-button>
              </el-tooltip>
            </div>
          </div>
          <div class="advantage-content">
            <div class="advantage-sub-title">Secbench⽹络安全⼤模型评测</div>
            <div class="dataset-des">
              <el-tooltip
                class="item"
                effect="light"
                content="腾讯朱雀实验室和腾讯安全科恩实验室联合腾讯混元⼤模型团队、清华⼤学江勇教授/夏树涛教授团队、⾹港理⼯⼤学罗夏朴教授研究团队以及上海⼈⼯智能实验室OpenCompass团队，共同建设业界⾸个⽹络安全⼤模型评测平台SecBench，旨在为⼤模型在安全领域的落地应⽤选择基座模型提供参考，加速⼤模型落地进程。同时，通过建设安全⼤模型评测基准，为安全⼤模型研发提供公平、公正、客观、全⾯的评测能⼒，推动安全⼤模型建设。"
                placement="right"
                :visible-arrow="false"
                popper-class="popper"
                style="border: none"
              >
                <el-button type="text">
                  腾讯朱雀实验室和腾讯安全科恩实验室联合腾讯混元⼤模型团队、清华⼤学江勇教授/夏树涛教授团队、⾹港理⼯⼤学罗夏朴教授研究团队以及上海⼈⼯智能实验室OpenCompass团队，共同建设业界⾸个⽹络安全⼤模型评测平台SecBench，旨在为⼤模型在安全领域的落地应⽤选择基座模型提供参考，加速⼤模型落地进程。同时，通过建设安全⼤模型评测基准，为安全⼤模型研发提供公平、公正、客观、全⾯的评测能⼒，推动安全⼤模型建设。
                </el-button>
              </el-tooltip>
            </div>
          </div>
          <div class="advantage-content">
            <div class="advantage-sub-title">腾讯混元⼤模型在研发安全漏洞修复的实践</div>
            <div class="dataset-des">
              <el-tooltip
                class="item"
                effect="light"
                content="⼤模型漏洞修复插件是腾讯朱雀实验室在安全垂类场景的⼀个᯿要实践。我们希望通过AI⼤模型，实现研发安全场景的漏洞⾃动修复，给出修复建议并提供修复代码，帮助更多开发⼈员提⾼研发效率。在腾讯混元⼤模型的⽀持下，漏洞修复插件通过精调后部署的私有化模型，实现了在帐密硬编码、SQL注⼊、命令注⼊等漏洞类型的修复建议输出和修复代码⽣成等功能，实现安全左移，更有效地在编程中使⽤插件收敛漏洞⻛险。"
                placement="right"
                :visible-arrow="false"
                popper-class="popper"
                style="border: none"
              >
                <el-button type="text">
                  ⼤模型漏洞修复插件是腾讯朱雀实验室在安全垂类场景的⼀个᯿要实践。我们希望通过AI⼤模型，实现研发安全场景的漏洞⾃动修复，给出修复建议并提供修复代码，帮助更多开发⼈员提⾼研发效率。在腾讯混元⼤模型的⽀持下，漏洞修复插件通过精调后部署的私有化模型，实现了在帐密硬编码、SQL注⼊、命令注⼊等漏洞类型的修复建议输出和修复代码⽣成等功能，实现安全左移，更有效地在编程中使⽤插件收敛漏洞⻛险。
                </el-button>
              </el-tooltip>
            </div>
          </div>
          <div class="advantage-content">
            <div class="advantage-sub-title">
              警惕Hugging Face开源组件⻛险被利⽤于⼤模型供应链攻击
            </div>
            <div class="dataset-des">
              <el-tooltip
                class="item"
                effect="light"
                content="近⽇，腾讯朱雀实验室发现著名AI社区Hugging Face开源组件datasets的不安全“特性”会引发供应链后⻔投毒攻击⻛险，AI开发者使⽤该组件加载攻击者构造的包含恶意代码的数据集时，会导致PC/服务器被⼊侵，同时在⼤模型预训练、微调等场景中，最终还可能导致⼤模型参数被窃取或篡改。"
                placement="right"
                :visible-arrow="false"
                popper-class="popper"
                style="border: none"
              >
                <el-button type="text">
                  近⽇，腾讯朱雀实验室发现著名AI社区Hugging
                  Face开源组件datasets的不安全“特性”会引发供应链后⻔投毒攻击⻛险，AI开发者使⽤该组件加载攻击者构造的包含恶意代码的数据集时，会导致PC/服务器被⼊侵，同时在⼤模型预训练、微调等场景中，最终还可能导致⼤模型参数被窃取或篡改。
                </el-button>
              </el-tooltip>
            </div>
          </div>
          <div class="advantage-content">
            <div class="advantage-sub-title">
              腾讯朱雀实验室推出“隐形”⽔印，助⼒打击AI模型盗取⾏为
            </div>
            <div class="dataset-des">
              <el-tooltip
                class="item"
                effect="light"
                content="全球知名信息安全峰会POC 2021正式举办，腾讯朱雀实验室受邀参加，并进⾏了题为《Towards AI Model Security Protection（AI模型的安全保护）》的分享。在此次分享中，腾讯朱雀实验室展示了AI模型攻防实例，并提出了⼀种新的模型⽔印⽣成⽅法，这项技术可以防御多种模型窃取⽅式，并且对原模型的输出⼏乎不产⽣影响，为AI模型版权提供有效的保护。"
                placement="right"
                :visible-arrow="false"
                popper-class="popper"
                style="border: none"
              >
                <el-button type="text">
                  全球知名信息安全峰会POC
                  2021正式举办，腾讯朱雀实验室受邀参加，并进⾏了题为《Towards AI Model Security
                  Protection（AI模型的安全保护）》的分享。在此次分享中，腾讯朱雀实验室展示了AI模型攻防实例，并提出了⼀种新的模型⽔印⽣成⽅法，这项技术可以防御多种模型窃取⽅式，并且对原模型的输出⼏乎不产⽣影响，为AI模型版权提供有效的保护。
                </el-button>
              </el-tooltip>
            </div>
          </div>
          <div class="advantage-content">
            <div class="advantage-sub-title">腾讯朱雀实验室推出代码防护技术Deep Puzzling</div>
            <div class="dataset-des">
              <el-tooltip
                class="item"
                effect="light"
                content="全球顶级的信息安全峰会HITB+Cyberweek 2021正式举办，腾讯朱雀实验室进⾏了题为《Deep Puzzling: Binary CodeIntention Hiding based on AI Uninterpretability》（《基于AI不可解释性的⼆进制代码意图隐藏》）的议题分享。会上，腾讯朱雀实验室展示了如何利⽤AI模型的特性，实现⼆进制代码的意图隐藏，有效防⽌代码被⿊客逆向分析，从⽽保障核⼼代码的安全。⽬前，朱雀实验室已将这项技术⾯向全球开发者开源，⽅便研究团队灵活取⽤，⽤前沿的AI技术助⼒⽹络安全的升级。"
                placement="right"
                :visible-arrow="false"
                popper-class="popper"
                style="border: none"
              >
                <el-button type="text">
                  全球顶级的信息安全峰会HITB+Cyberweek 2021正式举办，腾讯朱雀实验室进⾏了题为《Deep
                  Puzzling: Binary CodeIntention Hiding based on AI
                  Uninterpretability》（《基于AI不可解释性的⼆进制代码意图隐藏》）的议题分享。会上，腾讯朱雀实验室展示了如何利⽤AI模型的特性，实现⼆进制代码的意图隐藏，有效防⽌代码被⿊客逆向分析，从⽽保障核⼼代码的安全。⽬前，朱雀实验室已将这项技术⾯向全球开发者开源，⽅便研究团队灵活取⽤，⽤前沿的AI技术助⼒⽹络安全的升级。
                </el-button>
              </el-tooltip>
            </div>
          </div>
          <div class="advantage-content">
            <div class="advantage-sub-title">AI安全威胁⻛险矩阵</div>
            <div class="dataset-des">
              <el-tooltip
                class="item"
                effect="light"
                content="腾讯朱雀实验室联合腾讯AI Lab、⾹港中⽂⼤学（深圳）、深圳市⼤数据研究院，根据安全领域成熟的ATT&CK框架作为安全的理论依托，聚焦当前⼈⼯智能⻛险，涵盖AI⽣产运⾏环境下全⽣命周期过程中的安全问题，提出⼀套AI安全威胁⻛险矩阵，确保AI模型在不同的业务场景下的安全性，使其不会被攻击者轻易控制、影响、或欺骗，避免造成结果误判或隐私数据泄漏等严重后果。"
                placement="right"
                :visible-arrow="false"
                popper-class="popper"
                style="border: none"
              >
                <el-button type="text">
                  腾讯朱雀实验室联合腾讯AI
                  Lab、⾹港中⽂⼤学（深圳）、深圳市⼤数据研究院，根据安全领域成熟的ATT&CK框架作为安全的理论依托，聚焦当前⼈⼯智能⻛险，涵盖AI⽣产运⾏环境下全⽣命周期过程中的安全问题，提出⼀套AI安全威胁⻛险矩阵，确保AI模型在不同的业务场景下的安全性，使其不会被攻击者轻易控制、影响、或欺骗，避免造成结果误判或隐私数据泄漏等严重后果。
                </el-button>
              </el-tooltip>
            </div>
          </div>
          <div class="advantage-content">
            <div class="advantage-sub-title">腾讯披露新型AI攻击⼿法：操纵神经元构造后⻔</div>
            <div class="dataset-des">
              <el-tooltip
                class="item"
                effect="light"
                content="第19届XCon安全焦点信息安全技术峰会于北京举⾏，腾讯朱雀实验室⾸度亮相公众视线。该实验室由腾讯安全平台部孵化，专注于实战攻击技术研究和AI安全技术研究，以攻促防，守护腾讯业务及⽤户安全。会上，腾讯朱雀实验室分享了⼀项AI安全创新研究：模拟实战中的⿊客攻击路径，通过对AI模型⽂件的逆向分析，跳过传统利⽤“样本投毒”的攻击环节，直接控制AI模型的神经元，为模型“植⼊后⻔”。甚⾄在保留正常功能的前提下，直接在AI模型⽂件中插⼊⼆进制攻击代码，将模型⽂件改造为攻击载体来执⾏恶意代码，在⼏乎⽆感的情况下，实现对神经⽹络的深层次攻击。这也是国内⾸个利⽤AI模型⽂件直接产⽣后⻔效果的攻击研究。"
                placement="right"
                :visible-arrow="false"
                popper-class="popper"
                style="border: none"
              >
                <el-button type="text">
                  第19届XCon安全焦点信息安全技术峰会于北京举⾏，腾讯朱雀实验室⾸度亮相公众视线。该实验室由腾讯安全平台部孵化，专注于实战攻击技术研究和AI安全技术研究，以攻促防，守护腾讯业务及⽤户安全。会上，腾讯朱雀实验室分享了⼀项AI安全创新研究：模拟实战中的⿊客攻击路径，通过对AI模型⽂件的逆向分析，跳过传统利⽤“样本投毒”的攻击环节，直接控制AI模型的神经元，为模型“植⼊后⻔”。甚⾄在保留正常功能的前提下，直接在AI模型⽂件中插⼊⼆进制攻击代码，将模型⽂件改造为攻击载体来执⾏恶意代码，在⼏乎⽆感的情况下，实现对神经⽹络的深层次攻击。这也是国内⾸个利⽤AI模型⽂件直接产⽣后⻔效果的攻击研究。
                </el-button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div
          class="advantage contributor"
          style="height: auto !important; max-height: 1300px !important"
        >
          <div class="advantage-div flex">
            <div style="width: 45%">
              <div class="block-title tac">国际会议演讲</div>
              <div
                class="flex contributor-div"
                style="height: auto !important; max-height: 1000px !important"
              >
                <el-timeline>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2021年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    POC发表演讲《From Attack to Defense: Towards AI Model Security Protection》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    HITB AMS发表演讲《Model Robustness Will Hurt Data Privacy?》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    HITB+Cyberweek发表演讲《Deep Puzzling: Binary Code Intention Hiding Based on AI
                    Uninterpretability》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CanSecWest发表演讲《The Risk of AI Abuse: Be Careful with Your Voice》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    HITB AMS发表演讲《Attack Cloud Native Kubernetes》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CNCF KubeCon & CloudNativeCon & LinuxCon(Open Source Summit)发表演讲《Security
                    Practice of K8s luster Administrator》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    BlackHat Asia ARSENAL发表演讲《Zero Dependency Container Penetration Toolkit》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CanSecWest发表演讲《Silent Corner : Going Deeper into LPWAN Security》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    HITB AMS发表演讲《Silent Corner : Going Deeper into LPWAN Security》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    HITB AMS发表演讲《X-in-the-Middle : Attacking Fast Charging Piles and Electric
                    Vehicles》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    BlackHat ASIA发表演讲《X-in-the-Middle : Attacking Fast Charging Piles and
                    Electric Vehicles》
                  </el-timeline-item>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2020年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CanSecWest发表演讲《The Risk of AI Abuse：Towards Deepfake Attacks and
                    Defenses》
                  </el-timeline-item>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2019年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CanSecWest发表演讲《Adversarial Examples: Using AI to Cheat AI》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    DEFCON发表演讲《Breaking Google Home : Exploit It with SQLite》
                  </el-timeline-item>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2018年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    DEFCON发表演讲《Breaking Google Home : Exploit It with SQLite》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    DEFCON发表演讲《Breaking Smart Speaker : We are Listening to You》
                  </el-timeline-item>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2017年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    POC发表演讲《Hybrid App Security : Attack and Defense》
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
            <div>
              <div class="block-title tac">国内会议演讲</div>
              <div
                class="flex contributor-div"
                style="height: auto !important; max-height: 1000px !important"
              >
                <el-timeline>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2024年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    XCon发表演讲《LLM Infra Security：⼤模型供应链的阿喀琉斯之踵》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    QCon发表演讲《⼤模型软件供应链安全攻防》
                  </el-timeline-item>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2023年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    FCIS发表演讲《⼤模型时代下蓝军攻防实践》
                  </el-timeline-item>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2021年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    WHC发表演讲《A&D About Cluster Multi-Tenancy on Kubernetes》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    Kubernetes Community Days China发表演讲《云容器集群攻防体系建设》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    WAIC发表演讲《⼈⼯智能安全挑战与实践》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CIS发表演讲《光影照进现实：AI物理攻防的那些事⼉》
                  </el-timeline-item>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2020年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    XCon发表演讲《⿊掉神经⽹络:通过逆向模型⽂件来重构模型后⻔》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CIS发表演讲《Deep X-Ray: ⼀种机器学习驱动的WAF规则窃取器》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    ⼩⽶AIoT安全峰会发表演讲《破壁：探索IoT通信安全研究之道》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    华为银针安全沙⻰发表演讲《⼿机⽣物认证安全攻防》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CIS发表演讲《Attack in a Service Mesh》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    滴滴安全峰会发表演讲《漫谈企业内部安全蓝军建设实践》
                  </el-timeline-item>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2019年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CSS发表演讲《打破常“规”：挖掘语法解析器规则漏洞》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CIS⽹络安全创新⼤会发表演讲《浏览器漏洞挖掘之道-编写通⽤Fuzzer》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    京麒国际安全峰会发表演讲《企业应⽤容器化的攻与防》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CIS发表演讲《AI繁荣下的隐忧》
                  </el-timeline-item>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2018年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    中国互联⽹安全领袖峰会 TSec发表演讲《窃听⻛云：智能⾳箱安全》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    XCon发表演讲《IoT设备安全：从硬件破解到漏洞利⽤》
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
          </div>
        </div>
        <div
          class="advantage contributor"
          style="height: auto !important; max-height: 1300px !important; background: transparent"
        >
          <div class="advantage-div">
            <div>
              <div class="block-title tac">学术会议论⽂</div>
              <div
                class="flex contributor-div"
                style="height: auto !important; max-height: 1000px !important"
              >
                <el-timeline style="margin: auto">
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2024年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    ICLR workshop 《Adverarial Robustness for Visual Grounding of Multimodal Large
                    Language Models》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CVPR《Not All Prompts Are Secure: A Switchable Backdoor Attack against
                    Pre-trained Models》
                  </el-timeline-item>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2023年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    NeurIPS《Interpreting Unsupervised Anomaly Detection in Security via Rule
                    Extraction》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CVPR《Backdoor Defense via Adaptively Splitting Poisoned Dataset》
                  </el-timeline-item>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2022年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    NeurIPS《Untargeted Backdoor Watermark: Towards Harmless and Stealthy Dataset
                    Copyright Protection》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    CVPR《Towards Practical Deployment-Stage Backdoor Attack on Deep Neural
                    Networks》
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    ACL Workshop《TRAttack: Text Rewriting Attack Against Text Retrieval》
                  </el-timeline-item>
                  <el-timeline-item
                    icon="el-icon-more"
                    type="primary"
                    color="#0bbd87"
                    size="primary"
                    timestamp="2021年"
                    placement="top"
                  >
                  </el-timeline-item>
                  <el-timeline-item type="primary" size="primary" color="#0bbd87">
                    ICLR《Subnet Replacement: Deployment-stage backdoor attack against deep neural
                    networks in gray-boxsetting》
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
          </div>
        </div>
        <div class="advantage cooperate">
          <div class="advantage-div">
            <div class="block-title tac">⽐赛奖项</div>
            <div class="flex cooperate-div">
              <div class="advantage-content flex" style="align-items: center">
                <div class="cooperate-img cooperate-img-0"></div>
                <div>
                  <div class="prize-title">
                    GeekPwn 2020 新基建安全⼤赛 <span class="prize-content">破解成功</span>
                  </div>
                </div>
              </div>
              <div class="advantage-content flex" style="align-items: center">
                <div class="cooperate-img cooperate-img-0"></div>
                <div>
                  <div class="prize-title">
                    GeekPwn 2015 智能软硬件挑战赛 <span class="prize-content">破解成功</span>
                  </div>
                </div>
              </div>
              <div class="advantage-content flex" style="align-items: center">
                <div class="cooperate-img cooperate-img-0"></div>
                <div>
                  <div class="prize-title">
                    GeekPwn 2018 CAAD 对抗样本攻防赛 <span class="prize-content">成功</span>
                  </div>
                </div>
              </div>
              <div class="advantage-content flex" style="align-items: center">
                <div class="cooperate-img cooperate-img-0"></div>
                <div>
                  <div class="prize-title">
                    GeekPwn 2019 CAAD 隐身挑战赛 <span class="prize-content">成功</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
    <el-dialog :title="curDataset.dataset_name" :visible.sync="datasetVisible" width="30%">
      <json-viewer :value="{ data: curDataset.data_example }" :expand-depth="5" copyable>
      </json-viewer>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="datasetVisible = false" size="small" class="dataset-btn">
          关闭
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageFooter from '@/components/Footer';

export default {
  components: {
    PageFooter,
  },
  data() {
    return {
      dataset: [],
      curDataset: {},
      datasetVisible: false,
      contributors: [],
    };
  },
  methods: {
    scrollToSecond(event) {
      if (event.deltaY > 0) {
        // 滚动到下一屏
        this.$refs.container.setAttribute(
          'style',
          'width: 100%; height: 100%;transition: transform 400ms ease-in-out 0s; outline: none; transform: translate3d(0px, -100%, 0px);'
        );
      }
    },
    scrollToFirst(e) {
      if (e.deltaY < 0 && this.$refs.second.scrollTop === 0) {
        this.$refs.container.setAttribute(
          'style',
          'width: 100%; height: 100%;transition: transform 400ms ease-in-out 0s; outline: none; transform: translate3d(0px, 0%, 0px);'
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/_var.less';
@import '~@/assets/styles/_mixin.less';
.prize-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #252831;
}
.prize-content {
  color: #005aff;
  // color: #0bbd87;
  font-weight: 400;
  margin-top: 10px;
}
.el-timeline-item {
  padding-bottom: 5px;
}
.main-info {
  max-width: 780px;
  margin-top: 20px;
  // .justify-content(space-between);
  font-size: 14px;
  color: #000;
  .info-name {
    padding-right: 20px;
    color: #888;
    width: 42px;
  }
  & > div {
    width: 50%;
  }
}
.container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  .first,
  .second {
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  .second {
    padding-top: 95px;
  }
}
.el-button--primary {
  background-color: @color-primary;
  border-color: @color-primary;
}
.block-title {
  font-size: 28px;
  font-weight: 700;
  line-height: 42px;
  font-family: TencentSans;
  text-align: center;
  padding: 0 0 40px 0;
}
.banner-text {
  line-height: 22px;
  color: rgba(82, 92, 114, 0.9);
  font-weight: 400;
  max-width: 780px;
  font-family: Source Han Sans CN;
}

.banner {
  background: url(https://secbench-1258476245.cos.ap-guangzhou.myqcloud.com/secbench/banner.png)
      center 23px / auto 100% no-repeat,
    linear-gradient(72deg, rgb(221, 232, 240) 0%, rgb(223, 233, 241) 100%);
  width: 100%;
  height: calc(100vh / 2);
  min-height: 400px;
  .align-items();
  .justify-content(center);
  .banner-content {
    width: @width;
    .banner-title {
      color: @color-primary;
      font-size: 40px;
      line-height: 60px;
      margin-top: 20px;
      margin-bottom: 20px;
      font-family: TencentSans;
      font-weight: 700;
    }
    .banner-btn {
      margin-top: 10px;
      &:first-of-type {
        margin-right: 20px;
      }
    }
    .logos {
      margin-top: 47px;
      background-image: url('../../assets/images/logos.png');
      background-size: contain;
      background-repeat: no-repeat;
      width: 366px;
      height: 32px;
    }
  }
}

.advantage {
  background: #fff;
  width: 100%;
  height: calc(100vh - 400px);
  .align-items();
  max-height: calc(100vh / 2);
  & > div {
    margin: auto;
  }
}
.advantage-div {
  .justify-content(space-between);
  width: @width;
  margin: auto;
  .advantage-content {
    width: 290px;
    height: 145px;
    padding: 15px;
    background: linear-gradient(180deg, #f2f3f6 0%, rgba(242, 243, 246, 0) 54.93%);
    border: 1px solid rgba(243, 244, 246, 1);
    .advantage-img {
      width: 84px;
      height: 84px;
      background-size: contain;
      background-repeat: no-repeat;
      &.advantage-img-1 {
        background-image: url(../../assets/images/advantage_1.png);
      }
      &.advantage-img-2 {
        background-image: url(../../assets/images/advantage_2.png);
      }
      &.advantage-img-3 {
        background-image: url(../../assets/images/advantage_3.png);
      }
    }
    .advantage-content-div {
      padding: 0 10px 0 0;
      width: calc(100% - 84px);
      .advantage-text {
        color: #848c9b;
        line-height: 20px;
        padding-top: 8px;
      }
    }
    .advantage-sub-title {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      color: #252831;
    }
  }
}
.width {
  width: @width;
}
.dataset-text {
  max-width: @width;
}
.dataset-img {
  width: @width;
  height: 644px;
  background-image: url(https://secbench-1258476245.cos.ap-guangzhou.myqcloud.com/secbench/banner.png);
  background-size: 744px 553px;
  background-repeat: no-repeat;
  background-position: 50%;
  margin: 20px auto 20px auto;
  border: 2px solid #fff;
  background-color: linear-gradient(181.48deg, #f3f5f8 -3.38%, #fff 37.6%),
    linear-gradient(0deg, #fff, #fff);
  box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 0.6), 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
  background: url(../../assets/images/dataset.png) center center / 744px 553px no-repeat,
    linear-gradient(181.48deg, #f3f5f8 -3.38%, #fff 37.6%), linear-gradient(0deg, #fff, #fff);
}
.dataset-list {
  width: @width;
  flex-wrap: wrap;
  margin-top: 40px;
  & > div {
    width: 380px !important;
    margin-bottom: 25px;
    height: 205px !important;
    padding: 24px 20px !important;
    box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 1), 8px 8px 20px 0px rgba(55, 99, 170, 0.1) !important;
    border: 2px solid rgba(255, 255, 255, 1) !important;
    background: linear-gradient(180deg, #f3f5f8 0%, #fff 100%) !important;
  }
}
.tag {
  background: rgb(219, 232, 255);
  padding: 0 8px;
  border: none;
  border-radius: 0;
  color: @color-primary;
  height: 20px;
  line-height: 20px;
}
.dataset-tips {
  color: #aaa;
  line-height: 20px;
}
.dataset-divider {
  padding: 0 10px;
}
.show-data {
  color: @color-primary;
  line-height: 20px;
  cursor: pointer;
}
.dataset-info {
  .justify-content(space-between);
  padding: 20px 0 10px 0;
}
/deep/.dataset-des {
  button {
    width: 100%;
    text-align: left;
    span {
      color: #848c9b;
      font-weight: 400;
      width: 100%;
      display: -webkit-box;
      height: 110px;
      line-height: 22px;
      overflow: hidden;
      white-space: normal !important;
      word-break: break-all;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
    }
  }
}
.cooperate {
  background: #fff;
  // margin-top: 50px;
  padding: 50px 0 60px 0;
  height: auto;
  max-height: none;
  .block-title {
    padding-bottom: 26px;
  }
}
.cooperate-div {
  .justify-content(space-between);
  .advantage-content {
    box-shadow: 0px 8px 20px 0px rgba(55, 99, 170, 0.12), 0px -2px 20px 0px rgba(55, 99, 170, 0.02);
    background: #fff;
    border: none;
    height: 132px;
    width: 280px;
    .align-items;
    .justify-content(center);
  }
  .cooperate-img {
    background-size: contain;
    background-repeat: no-repeat;
  }
  .cooperate-img-0 {
    width: 89px;
    height: 69px;
    background-image: url(../../assets/images/geekpwn.jpeg);
  }
  .cooperate-img-1 {
    width: 162px;
    height: 51px;
    background-image: url(../../assets/images/geekpwn.jpeg);
  }
  .cooperate-img-2 {
    width: 240px;
    height: 46px;
    background-image: url(../../assets/images/geekpwn.jpeg);
  }
  .cooperate-img-3 {
    width: 238px;
    height: 41px;
    background-image: url(../../assets/images/geekpwn.jpeg);
  }
}
.connect-content {
  background: #242933;
  .connect {
    font-size: 28px;
    line-height: 42px;
    font-weight: 700;
    color: #fff;
    font-family: TencentSans;
    background-image: url(../../assets/images/connect.png);
    background-repeat: no-repeat;
    background-size: 376px 234px;
    background-position-y: 27px;
    margin: auto;
    width: @width;
    height: 100%;
    padding: 60px 0;
    .el-link {
      font-size: 28px;
      line-height: 42px;
      font-weight: 300;
    }
  }
}
.dataset-btn {
  width: 88px;
}
.more-dataset {
  color: @color-primary;
  font-size: 16px;
  line-height: 22px;
  .el-link.el-link--primary {
    font-size: 16px;
  }
}
/deep/.el-dialog__footer {
  text-align: center;
}
.contributor {
  max-height: 560px !important;
  height: 560px !important;
  margin-top: 50px;
  background: #fff;
  padding: 50px;
  & > div {
    // height: 400px;
    .contributor-div {
      margin: auto;
      margin-top: 20px;
      .justify-content(space-between);
      & > div {
        &:hover {
          transform: scale(1.05);
        }
        transition: transform 1s ease 0s, -webkit-transform 1s ease 0s;
        width: 250px;
        height: 270px;
        box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 0.6),
          8px 8px 20px 0px rgba(55, 99, 170, 0.1);
        border-radius: 20px;
        border: 2px solid #fff;
        background: linear-gradient(180deg, #f3f5f8 0%, #fff 100%);
        background: linear-gradient(181.48deg, #f3f5f8 -3.38%, #fff 37.6%),
          linear-gradient(0deg, #fff, #fff);
        &:nth-of-type(2) {
          height: 300px;
        }
        & > div {
          text-align: center;
        }
        .avator {
          width: 115px;
          height: 115px;
          margin: 45px auto auto auto;
          border-radius: 50%;
          & > div {
            width: 100px;
            height: 100px;
            background-size: contain;
            background-repeat: no-repeat;
            border-radius: 50%;
            margin: auto;
          }
          &.avator-1 {
            border: 5px solid #b6bfcd;
          }
          &.avator-2 {
            margin: 25px auto auto auto;
            width: 135px;
            height: 135px;
            border: 5px solid #f3d04b;
            & > div {
              width: 120px;
              height: 120px;
            }
          }
          &.avator-3 {
            border: 5px solid #b0763c;
          }
        }
        .username {
          padding-top: 10px;
          font-size: 16px;
          font-weight: 700;
        }
        .score {
          padding-top: 10px;
          font-weight: 700;
          &.score-1 {
            color: #b6bfcd;
          }
          &.score-2 {
            color: #f3d04b;
          }
          &.score-3 {
            color: #b0763c;
          }
          .score-item {
            font-family: TCloud Number;
            font-size: 18px;
            font-weight: bold;
            padding-right: 3px;
          }
        }
      }
    }
  }
  .more-dataset {
    margin-top: 30px;
  }
}
.info-link {
  font-size: 14px;
  margin-left: 10px;
  margin-top: -2px;
  text-decoration: underline;
}
</style>
